import React, { useEffect } from "react";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import { Grid, Toolbar, Alert, TextField, Dialog, } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import bannerBg from "../../assets/images/congratulation/bg-green.svg";
// import { ReactComponent as StarIcon } from "../../assets/images/congratulation/star.svg";
import StarIcon from "../../assets/images/congratulation/star.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useParams, useNavigate } from "react-router-dom";
import SupportService from "../../services/support.service";
import { makeStyles, styled } from "@mui/styles";
import FeedbackRating from "../../constants/Feedback";


const styles = {
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#F7B254",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        maxHeight: "100%",
        height: "250px",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
    },
    icon: {
        position: "absolute",
        bottom: "-23%",
        margin: "0 auto",
        left: 0,
        right: 0
    },
};



export default function Congrtulations(props) {
    const { t } = useTranslation()
    const { formID, name, editor, nameEmployee } = props;
    const [comment, setComment] = React.useState("");
    const [rating, setRating] = React.useState("");

    const navigate = useNavigate();
    const handleClose = async () => {

        if (rating != '' || comment != '') {
            try {
                let data = { form_evaluate_id: formID, rating, comment }

                await SupportService.sendFeedback(data)

            } catch (error) {
                console.error('Cannot submit feedback', error)
            }
        }

        props.setValue(false)
    };
    const useStyles = makeStyles({
        firework: {

            "& .firework": {
                position: "absolute",
                "border-radius": "50%",
                width: "7.5px",
                height: "7.5px",
            },
            "& .firework1": {
                animation: `$firework-sm 1.2s both infinite`,
                "animation-delay": "0.7s",
                top: "25%",
                left: "10%",
            },
            "& .firework2": {
                animation: `$firework-md 1.2s both infinite`,
                "animation-delay": "0.4s",
                top: "35%",
                left: "85%",
            },
            "& .firework3": {
                animation: `$firework-lg 1.2s both infinite`,
                "animation-delay": "1.1s",
                top: "50%",
                left: "40%",
            },
        },
        "@keyframes firework-sm": {
            "0%, 100%": {
                opacity: 0,
            },
            "10%, 70%": {
                opacity: 1,
            },
            "100%": {
                "box-shadow": "-30px 0rem 0 #fff, 30px 0rem 0 #fff, 0rem -30px 0 #fff, 0rem 30px 0 #fff, 20px -20px 0 #fff, 20px 20px 0 #fff, -20px -20px 0 #fff, -20px 20px 0 #fff",
            },
        },
        "@keyframes firework-md": {
            "0%, 100%": {
                opacity: 0,
            },
            "10%, 70%": {
                opacity: 1,
            },
            "100%": {
                "box-shadow": "-45px 0rem 0 #fff, 45px 0rem 0 #fff, 0rem -45px 0 #fff, 0rem 45px 0 #fff, 30px -30px 0 #fff, 30px 30px 0 #fff, -30px -30px 0 #fff, -30px 30px 0 #fff",
            },
        },
        "@keyframes firework-lg": {
            "0%, 100%": {
                opacity: 0,
            },
            "10%, 70%": {
                opacity: 1,
            },
            "100%": {
                "box-shadow": "-60px 0rem 0 #fff, 60px 0rem 0 #fff, 0rem -60px 0 #fff, 0rem 60px 0 #fff, 40px -40px 0 #fff, 40px 40px 0 #fff, -40px -40px 0 #fff, -40px 40px 0 #fff",
            },
        },
        boxIcon: {
            backgroundColor: "#ffffff",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.15)",
            border: "none",
            transition: "0.5s",
            cursor: "pointer",
            margin: "0 20px",
            "&:hover": {
                transition: "0.5s",
                animation: `$shadow 1.2s infinite`,
                transform: "scale(1.2)",
            },
        },
        "@keyframes shadow": {
            // "0%": {
            //     "box-shadow": "5px 5px 10px rgb(93, 161, 150),-5px -5px 20px rgb(93, 161, 150)"
            // },
            // "50%": {
            //     "box-shadow": "5px 5px 10px rgb(81, 224, 210),- 5px - 5px 20px rgb(81, 224, 210)"
            // },
            // "100%": {
            //     "box-shadow": "5px 5px 10px rgb(93, 161, 150),- 5px - 5px 20px rgb(93, 161, 150)"
            // },
            "0%": {
                "box-shadow": " 0 0 0 0px rgba(93, 161, 150, 0.8)"
            },
            "100%": {
                "box-shadow": " 0px 0px 10px rgba(93, 161, 150, 0.5)"
            }
        },
    })
    const classes = useStyles();
    // const handleClose = () => {
    //     onClose();
    // };

    const dispatch = useDispatch();
    let remark = ""
    useEffect(() => {
    }, []);
    const handleChange = (event) => {
        console.log(event.target.value)

    };
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    const language = localStorage.getItem("lang");

    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={handleClose}
                onBackdropClick={() => { return false }} maxWidth='md'
                fullWidth
                sx={{
                    '.MuiPaper-root':
                    {
                        "maxWidth": "780px",
                        borderRadius: "25px"
                    }
                }}
            >

                {/* <DialogContent> */}
                <Grid item lg={12} md={12}>
                    <Grid item container>
                        <Box sx={{ backgroundColor: "#ffffff", width: "100%" }}>
                            <Box sx={{ position: "relative" }} className={`${classes.firework}`}>
                                <img src={bannerBg} alt="" style={{ maxWidth: "100%" }} />
                                <Box className="firework firework1"></Box>
                                <Box className="firework firework2"></Box>
                                <Box className="firework firework3"></Box>
                                {/* <StarIcon style={styles.icon} /> */}
                                <img src={StarIcon} alt="" style={styles.icon} />
                            </Box>
                            <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "center", paddingTop: "75px", width: "100%" }}>
                                <Typography fontSize={40} lineHeight="59.8px" fontWeight={600} >{t('evaluation.congratulations')}</Typography>
                                {editor === "evaluator" ?
                                    <Typography fontSize={18} lineHeight="26.91px" fontWeight={400} pt={2} pb={1} sx={{ textAlign: "center" }} >{language === "en-US" ? "You’ve completed the" + " " + name + " " + "of" + " " + nameEmployee : "คุณได้ประเมิน" + " " + name + "ของ" + nameEmployee + " " + "เสร็จเรียบร้อย"}</Typography>
                                    :
                                    <Typography fontSize={18} lineHeight="26.91px" fontWeight={400} pt={2} pb={1} sx={{ textAlign: "center" }} >{language === "en-US" ? "You’ve completed the" + " " + name : "คุณได้ประเมิน" + " " + name + " " + "เสร็จเรียบร้อย"}</Typography>
                                }
                                <Button onClick={handleClose} size="medium" variant="contained" sx={{ width: '250px', color: "#fff!important", fontSize: '18px', lineHeight: '19.8px', paddingTop: '10px', paddingBottom: '10px', margin: "20px 0" }} >{t('label.close')}</Button>
                                {editor === "evaluator" ?
                                    <Typography fontSize={16} lineHeight="23.92px" fontWeight={400} pb={4}
                                        sx={{ textDecoration: "underline", cursor: "pointer", '&:hover': { color: 'rgb(65, 112, 105) !important' }, transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", }} color="primary"
                                        onClick={e => navigate(`/kpi/performance-evaluation`, { replace: false })}>
                                        {t('evaluation.backToManage')}
                                    </Typography>
                                    :
                                    <Typography fontSize={16} lineHeight="23.92px" fontWeight={400} pb={4}
                                        sx={{ textDecoration: "underline", cursor: "pointer", '&:hover': { color: 'rgb(65, 112, 105) !important' }, transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", }} color="primary"
                                        onClick={e => navigate(`/kpi/evaluation`, { replace: false })}>
                                        {t('evaluation.backToMyEvaluation')}
                                    </Typography>
                                }
                            </Box>
                        </Box>
                        <Box sx={{ backgroundColor: "#F5F5F5", width: "100%", "box-shadow": "inset 0px 4px 5px rgba(0, 0, 0, 0.05)" }}>
                            <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "center", paddingTop: "25px", width: "100%" }}>
                                <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} >{t('evaluation.experienceWithIPOP')} </Typography>
                                <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} pt="5px" sx={{ color: "#939393" }} >{t('evaluation.feedback')}</Typography>
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0px" }}>

                                    {FeedbackRating.map((rating, i) => (
                                        <BootstrapTooltip title={rating.label} placement="top" key={i}>
                                            <Box className={`${classes.boxIcon}`}>
                                                <img src={rating.icon} alt={rating.label} onClick={() => setRating(rating.id)}></img>
                                            </Box>
                                        </BootstrapTooltip>
                                    ))}
                                </Box>
                                <Box sx={{ maxWidth: "500px", width: "100%" }}>
                                    <TextField
                                        fullWidth
                                        name="comment"
                                        placeholder={t('evaluation.pleaseLeaveYourComment')}
                                        onChange={(e) => setComment(e.target.value)}
                                        value={comment}
                                        variant="outlined"
                                        multiline
                                        rows={2}
                                    />
                                </Box>
                                <Typography fontSize={10} lineHeight="14.95px" fontWeight={400} variant="sub_label" pt="10px" pb="15px">{t('evaluation.characterDesignBy')} <span style={{ color: "#939393", fontWeight: "500" }}>SODA</span></Typography>
                            </Box>
                        </Box>

                    </Grid>
                </Grid>
                {/* </DialogContent> */}
            </Dialog>
        </React.Fragment>
    );
}